import Endpoints from '@/config/ApiEndpoints.js';
import Axios from 'axios';
import LicenceCategories from "@/assets/json_data/licence_categories.json";
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators';
import $ from "jquery";

export default {
	components:{

	},
	data() {
		return {
			ShowLoader: false,
			Saving: false,
			submitted: false,
			FileLoader: false,			
			file: '',
			Branches:{},
			NewTask: {				
				vehicle_id: '',
				driver_id: '',
				title: '',
				notes: '',
				date: '',
				time: '',
				location: '',				
				file: '',
				Vehicle:[],				
				Driver:[],				
			},
			FleetSubscription:[],
			select_branch:true,
			FleetSubscriptionModules:[] ,
			Vehicles: [],      
      		Drivers: [],    
		}
	},
	validations: {
	    NewTask: {
			title: { required },
			notes: { required },
			date: { required },			
	    },
  	},
	mounted() {
		/*this.FleetSubscription = JSON.parse(localStorage.getItem("FleetSubscription"));
		var FleetSubscriptionModules = JSON.parse(this.FleetSubscription.fleet_modules);
		this.FleetSubscriptionModules = FleetSubscriptionModules;*/
		document.title = pbx_SiteTitle+' - Driver Add';
		let CompanyData = JSON.parse(localStorage.getItem('Company'));
		this.NewTask.company_name = CompanyData.name;		
		//this.GetBranches();
		this.GetVehiclesList();
		this.GetDriversList();		
	},

	methods : {
		/*GetBranches(){
			var obj = { token: localStorage.getItem("token"), select_branch: true };
			Axios.post(Endpoints.Branch.List, obj).then((Response) => {
				if (Response?.data?.success) {
					this.Branches = Response.data.records;
					if(this.FleetSubscriptionModules["Hierarchy System"] && this.Branches.length == 1){
						this.NewTask.branch_id = this.Branches[0].id;
						this.select_branch = false;
					}
				}
			});
		},*/								
		GetVehiclesList(){
			var obj={token: localStorage.getItem('token')}
			Axios.post(Endpoints.Vehicle.List, obj).then((Response) => {
				if (Response?.data?.success) {
					this.Vehicles = Response.data.vehicles
				}
			})
		},
		GetDriversList(type = "") {
	      var obj = { token: localStorage.getItem("token") };	      
	      Axios.post(Endpoints.Driver.List, obj).then((Response) => {
	        if (Response?.data?.success) {
	          this.Drivers = Response.data.drivers;	          
	        }
	      });
	    },
		handleFileUpload() {
      		this.file = this.$refs.file.files[0];
    	},
		CreateTaskData() {
			this.submitted = true;
	      	this.$v.$touch();	      	
	      	if (this.$v.$invalid) {
	        	return;
	      	}
	      	this.Saving = true;
			let formData = new FormData();
			if (this.$refs.file && this.$refs.file.files[0]) {
			formData.append('token', localStorage.getItem('token'));
			formData.append('storage_type', 'CFD');
			formData.append('file', this.file);
			Axios.post(Endpoints.File.Upload, formData).then((Response) => {
				this.Saving = false;
				if (Response?.data?.success == true) {
				  	this.NewTask.file = Response.data.file;
				  	this.CreateTask();
				} else {
					this.$swal.fire('Error in File Uploading', '', 'error').then(() => {});
				}
			});
		}else{
			this.CreateTask();
		}
    	},		
		CreateTask() {			
	      	Axios.post(Endpoints.Task.Create, {token: localStorage.getItem('token'),...this.NewTask}).then((Response) => {
	        	this.Saving = false;
	        	if (Response?.data?.success) {
					this.$swal.fire('Task Added Successfully', '', 'success').then(() => {
	            		this.$router.push('/dashboard/home');
	          		});
	        	} else {
					this.$swal.fire({
	            		title: 'Oops!',
	            		text: Response?.data?.message || "Something went wrong",
	            		icon: 'error',
	            		confirmButtonText: 'Close',
	          		});
        		}
	      	});
    	},

	}
}
